<template>
  <div>
    <Home/>
  </div>
</template>
<script setup>

import { watch } from "vue"
import { useI18n } from "vue-i18n"
import { useRoute, useRouter } from "vue-router"

import Home from '../views/LandingHome.vue'

const { locale } = useI18n();
const route = useRoute();
const router = useRouter();

// Sync locale to URL query
watch(
  () => locale.value,
  (newLang) => {
    const query = { ...(route?.query || {}), lang: newLang };
    if (router && typeof router.replace === 'function') {
      router.replace({ query });
    }
  }
)
</script>
<style lang="scss">
.content-center {
  margin: 0 auto;
}

.capitalize {
  text-transform: capitalize;
}

.root-logo {
  width: 100%;
}

.side-nav {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  /* background: #4fdcab; */
  /* background: #4fdcab; */
}

.side-nav ul li a {
  text-decoration: none;
}

ul {
  list-style-type: none;
  padding: 0;
  margin: 1rem 0;
}

li {
  margin-bottom: 0.5rem;
}

a {
  text-decoration: none;
  color: #333;
}

// .container {
//   margin-left: calc(270px + 1rem);
//   margin-top: 30px;
//   flex: calc(280px + 70%);
// }

.app-header {
  position: fixed;
  background-color: #ffffff;
  top: 0;
  width: 100%;

  main {
    flex: 1 1 0;
    padding: 2rem;
    // @media (max-width: 1024px) {
    // 	padding-left: 6rem;
    // }
  }
}
</style>
